<template>
  <el-checkbox-group :value="value" @input="emitInput">
    <el-checkbox
      v-for="mapper in options"
      :key="mapper.value"
      :label="mapper.value">
      {{ mapper.text }}
    </el-checkbox>
  </el-checkbox-group>
</template>

<script>
export default {
  name: 'FwCheckboxGroup',
  props: {
    value: {
      type: Array,
      default: () => ([])
    },
    options: {
      type: Array,
      default: () => ([])
    }
  },
  data () {
    return {}
  },
  methods: {
    emitInput (value) {
      this.$emit('input', value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Common/FwCheckboxGroup.vue